<template>
	<v-container class="mt-12 pt-8" style="background: #fafafa;">
		<v-row style="background: #fafafa;">
			<v-col cols="12" class="mx-auto" PANNELS>
				<v-card :loading="loading">
					<v-card-title :class="`${arabic ? 'arFont' : 'enFont'}`">
						{{ i18n["past_evaluations"] }}
					</v-card-title>
					<Paging 
						:resourceSettings="resourceSettings" 
						:resource="resource" 
						@loadResource="loadResource"
						@pageByNumber="pageByNumber" />
					<v-card-text>
						<v-row>
							<v-col cols="12" :class="`${arabic ? 'arFont' : 'enFont'}`" class="mb-2 py-0">
								<v-timeline dense clipped>
									<v-timeline-item  v-for="(evaluation, key) in resource.data" :key="`evaluation-${key}`" :color="evaluation.attended ? 'success' : 'red'" small>
										<v-row class="elevation-1 pa-4 py-2">
											<v-col>
												<v-row class="align-center">
													<v-col class="pa-0 col-auto">
														<v-avatar size="40" color="primary">
															<span class="white--text text-h5">{{ firstLettersName(evaluation.employee_name.name) }}</span>
														</v-avatar>
													</v-col>
													<v-col>
														<div style="font-size:11px;font-weight:700;">{{ i18n.employee }}</div>
														<strong>{{ evaluation.employee_name.name }}</strong>
													</v-col>
												</v-row>
												<v-row>
													<v-col cols="12" md="4" class="pa-0 mb-md-0 mb-3">
														<div style="font-size:11px;font-weight:700;">{{ i18n.evaluation_appointment }}</div>
														<div class="body-1">
															<v-chip color="blue darken-1" dark small>
																{{ formatDateToCurrentLocale(evaluation.appointment.appointment)[0] }}
															</v-chip>
															<v-chip color="blue darken-1" dark class="mr-2" small>
																{{ formatDateToCurrentLocale(evaluation.appointment.appointment)[1] }}
															</v-chip>
														</div>
													</v-col>
													<v-col cols="12" md="4" class="pa-0 mb-md-0 mb-3">
														<div style="font-size:11px;font-weight:700;">{{ i18n.evaluation_update_date }}</div>
														<div class="body-1">{{ getFormat(evaluation.updated_at) }}</div>
													</v-col>
													<v-col cols="12" md="4" class="pa-0 mb-md-0 mb-3">
														<div style="font-size:11px;font-weight:700;">{{ i18n.was_present }}</div>
														<div class="body-1">{{ evaluation.attended ? i18n.yes : i18n.no }}</div>
													</v-col>
												</v-row>
												<v-row v-if="evaluation.note" class="mt-md-2 ">
													<v-col cols="12" class="pa-0">
														<div style="font-size:11px;font-weight:700;">{{ i18n.evaluation_note }}</div>
														<div class="body-1">
															{{ evaluation.note }}
														</div>
													</v-col>
												</v-row>
												<v-row v-if="evaluation.result" class="mt-2">
													<v-col col="12" class="pa-0">
														<div class="mb-1">
															<div style="font-size:11px;font-weight:700;">{{ i18n.evaluation_result }}</div>
														</div>
														<v-chip label small color="blue" dark>
															{{ evaluation.result }}
														</v-chip>
													</v-col>
												</v-row>
											</v-col>
										</v-row>
									</v-timeline-item>
								</v-timeline>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { format } from 'timeago.js';
import Paging from '@/components/Paging'

export default {
	components: {
			Paging
	},
	data() {
		return {
			loading: false,
			resourceSettings: {
				resourceName: null,
				search: false,
				create: false,
				pagination: true,
			},
			resource: []
		}
	},
	computed: {
		user() {
			return this.$store.state.user
		},
		language() {
			return this.$store.state.language
		},
		i18n() {
			return this.$store.state.i18n[this.$store.state.language]
		},
		arabic() {
			if (this.$store.state.language == 'ar') return true
		},
	},
	methods: {
		formatDateToCurrentLocale(date) {
			let new_date = (new Date(date))
			return [
				new_date.toLocaleDateString(this.arabic ? 'ar' : 'en', {
					day: 'numeric',
					year: 'numeric',
					month: 'short',
				}),
				new_date.toLocaleTimeString(this.arabic ? 'ar' : 'en'),
			]
		},
		firstLettersName(name) {
			const split_names = name.split(" ")

			if (split_names.length > 1) return (split_names[0][0] + split_names[1][0]).toUpperCase()
			
			return (split_names[0][0] + split_names[0][1]).toUpperCase()
		},
		async pageByNumber(n) {
			return new Promise(async (res, rej) => {
					this.loading = true
					if (!this.search) {
							this.resource = await this.$store.dispatch('getResource', { resource: '/evaluations', page: `?page=${n}` })
					} else {
							this.resource = await this.$store.dispatch('searchResource', { resource: '/evaluations' + `/search?page=${n}`, value: this.search })
					}
					this.loading = false
			})
		},
		getFormat(d){
			return format(d)
		},
		async loadResource() {
				return new Promise(async (res, rej) => {
		this.resource = await this.$store.dispatch('getResource', { resource: '/evaluations' })
						res()
				})
		},
		async init() {
				this.loading = true
				await this.loadResource()
				this.loading = false
		},
	},
	async created() {
			await this.init()
	},
}
</script>